import * as actionTypes from 'constants/ActionTypes';

export function getIssues(pagination) {
    return {
        type: actionTypes.GET_ISSUES.REQUEST,
        pagination,
    };
}

export function getIssue(id) {
    return {
        type: actionTypes.GET_ISSUE.REQUEST,
        id,
    };
}

export function updateIssueStatus(id, status) {
    return {
        type: actionTypes.UPDATE_ISSUE_STATUS.REQUEST,
        id,
        status
    };
}

export function addIssueComment(id, data) {
    return {
        type: actionTypes.ADD_ISSUE_COMMENT.REQUEST,
        id,
        data,
    };
}

export function updateIssueComment(id, commentId, data) {
    return {
        type: actionTypes.UPDATE_ISSUE_COMMENT.REQUEST,
        id,
        commentId,
        data,
    };
}

export function deleteIssueComment(id, commentId) {
    return {
        type: actionTypes.DELETE_ISSUE_COMMENT.REQUEST,
        id,
        commentId,
    };
}



// WEBPACK FOOTER //
// ./app/actions/issues.js